import debounce from 'lodash.debounce'
export default debounce



// WEBPACK FOOTER //
// ./~/vux/src/tools/debounce/index.js